import PropTypes from "prop-types";
import { Alert } from "@mui/material";

const CatalogTabStatusMessage = ({ message, severity = "info" }) => {
  if (!message) {
    return null;
  }

  return (
    <Alert className="cm-tab-status-message" severity={severity}>
      {message}
    </Alert>
  );
};

CatalogTabStatusMessage.propTypes = {
  message: PropTypes.string,
  severity: PropTypes.oneOf(["error", "warning", "info", "success"]),
};

export default CatalogTabStatusMessage;
